import React, { Component } from 'react';
import { GalleryTemplates, INDUSTRIES } from '../../config/template_gallery';
import { LANGUAGE_PRESETS } from '../../config/template_labels';

function formatDateExample(format) {
    const d = new Date();
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return format.replace('DD', dd).replace('MM', mm).replace('YYYY', yyyy);
}

const COUNTRY_CONFIG = {
    DE: { language: 'de', showVTA: true, taxLabel: 'VAT (MwSt.)', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    AT: { language: 'de', showVTA: true, taxLabel: 'VAT (USt.)', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    CH: { language: 'de', showVTA: true, taxLabel: 'VAT (MWST)', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    FR: { language: 'fr', showVTA: true, taxLabel: 'TVA', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    BE: { language: 'fr', showVTA: true, taxLabel: 'TVA/BTW', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    ES: { language: 'es', showVTA: true, taxLabel: 'IVA', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    PT: { language: 'pt', showVTA: true, taxLabel: 'IVA', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    IT: { language: 'it', showVTA: true, taxLabel: 'IVA', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    NL: { language: 'nl', showVTA: true, taxLabel: 'BTW', dateFormat: 'DD-MM-YYYY', industry: 'retail' },
    RO: { language: 'ro', showVTA: true, taxLabel: 'TVA', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    PL: { language: 'pl', showVTA: true, taxLabel: 'VAT', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    CZ: { language: 'cs', showVTA: true, taxLabel: 'DPH', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    SK: { language: 'sk', showVTA: true, taxLabel: 'DPH', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    HU: { language: 'hu', showVTA: true, taxLabel: 'ÁFA', dateFormat: 'YYYY.MM.DD', industry: 'retail' },
    BG: { language: 'bg', showVTA: true, taxLabel: 'ДДС', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    HR: { language: 'hr', showVTA: true, taxLabel: 'PDV', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    EL: { language: 'el', showVTA: true, taxLabel: 'ΦΠΑ', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    GR: { language: 'el', showVTA: true, taxLabel: 'ΦΠΑ', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    SE: { language: 'sv', showVTA: true, taxLabel: 'Moms', dateFormat: 'YYYY-MM-DD', industry: 'retail' },
    DK: { language: 'da', showVTA: true, taxLabel: 'Moms', dateFormat: 'DD-MM-YYYY', industry: 'retail' },
    NO: { language: 'no', showVTA: true, taxLabel: 'MVA', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    FI: { language: 'fi', showVTA: true, taxLabel: 'ALV', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    LT: { language: 'lt', showVTA: true, taxLabel: 'PVM', dateFormat: 'YYYY-MM-DD', industry: 'retail' },
    LV: { language: 'lv', showVTA: true, taxLabel: 'PVN', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    EE: { language: 'et', showVTA: true, taxLabel: 'KM', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    SI: { language: 'sl', showVTA: true, taxLabel: 'DDV', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    RS: { language: 'sr', showVTA: true, taxLabel: 'PDV', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    TR: { language: 'tr', showVTA: true, taxLabel: 'KDV', dateFormat: 'DD.MM.YYYY', industry: 'retail' },
    GB: { language: 'en', showVTA: true, taxLabel: 'VAT', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    IE: { language: 'en', showVTA: true, taxLabel: 'VAT', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    IN: { language: 'en', showVTA: true, taxLabel: 'GST', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    AU: { language: 'en', showVTA: true, taxLabel: 'GST', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    NZ: { language: 'en', showVTA: true, taxLabel: 'GST', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    SG: { language: 'en', showVTA: true, taxLabel: 'GST', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    CA: { language: 'en', showVTA: true, taxLabel: 'GST/HST', dateFormat: 'YYYY-MM-DD', industry: 'retail' },
    US: { language: 'en', showVTA: false, taxLabel: 'Sales Tax', dateFormat: 'MM/DD/YYYY', industry: 'retail' },
    JP: { language: 'ja', showVTA: true, taxLabel: '消費税', dateFormat: 'YYYY/MM/DD', industry: 'retail' },
    CN: { language: 'zh', showVTA: true, taxLabel: '增值税', dateFormat: 'YYYY-MM-DD', industry: 'retail' },
    AE: { language: 'ar', showVTA: true, taxLabel: 'VAT', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    SA: { language: 'ar', showVTA: true, taxLabel: 'VAT', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    IL: { language: 'en', showVTA: true, taxLabel: 'VAT', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    ZA: { language: 'en', showVTA: true, taxLabel: 'VAT', dateFormat: 'YYYY/MM/DD', industry: 'retail' },
    BR: { language: 'pt', showVTA: true, taxLabel: 'ICMS', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    MX: { language: 'es', showVTA: true, taxLabel: 'IVA', dateFormat: 'DD/MM/YYYY', industry: 'retail' },
    UA: { language: 'uk', showVTA: true, taxLabel: 'ПДВ', dateFormat: 'DD.MM.YYYY', industry: 'retail' }
};

const COUNTRIES = [
    { code: 'US', name: 'United States' }, { code: 'GB', name: 'United Kingdom' }, { code: 'CA', name: 'Canada' },
    { code: 'AU', name: 'Australia' }, { code: 'DE', name: 'Germany' }, { code: 'FR', name: 'France' },
    { code: 'ES', name: 'Spain' }, { code: 'IT', name: 'Italy' }, { code: 'NL', name: 'Netherlands' },
    { code: 'BE', name: 'Belgium' }, { code: 'AT', name: 'Austria' }, { code: 'CH', name: 'Switzerland' },
    { code: 'PT', name: 'Portugal' }, { code: 'IE', name: 'Ireland' }, { code: 'SE', name: 'Sweden' },
    { code: 'DK', name: 'Denmark' }, { code: 'NO', name: 'Norway' }, { code: 'FI', name: 'Finland' },
    { code: 'PL', name: 'Poland' }, { code: 'CZ', name: 'Czech Republic' }, { code: 'SK', name: 'Slovakia' },
    { code: 'HU', name: 'Hungary' }, { code: 'RO', name: 'Romania' }, { code: 'BG', name: 'Bulgaria' },
    { code: 'HR', name: 'Croatia' }, { code: 'SI', name: 'Slovenia' }, { code: 'RS', name: 'Serbia' },
    { code: 'GR', name: 'Greece' }, { code: 'TR', name: 'Turkey' }, { code: 'UA', name: 'Ukraine' },
    { code: 'LT', name: 'Lithuania' }, { code: 'LV', name: 'Latvia' }, { code: 'EE', name: 'Estonia' },
    { code: 'IN', name: 'India' }, { code: 'NZ', name: 'New Zealand' }, { code: 'SG', name: 'Singapore' },
    { code: 'JP', name: 'Japan' }, { code: 'CN', name: 'China' }, { code: 'AE', name: 'United Arab Emirates' },
    { code: 'SA', name: 'Saudi Arabia' }, { code: 'IL', name: 'Israel' }, { code: 'ZA', name: 'South Africa' },
    { code: 'BR', name: 'Brazil' }, { code: 'MX', name: 'Mexico' }
];

const COLOR_PALETTES = [
    { name: 'Navy', colors: { color1: '#1e3a5f', color2: '#ffffff', color3: '#e2e8f0', color4: '#1e3a5f', color5: '#0ea5e9' } },
    { name: 'Charcoal', colors: { color1: '#2d3436', color2: '#ffffff', color3: '#dfe6e9', color4: '#2d3436', color5: '#00b894' } },
    { name: 'Forest', colors: { color1: '#1b4332', color2: '#ffffff', color3: '#d8f3dc', color4: '#1b4332', color5: '#52b788' } },
    { name: 'Royal', colors: { color1: '#2c2c54', color2: '#ffffff', color3: '#e8e8f0', color4: '#2c2c54', color5: '#706fd3' } },
    { name: 'Warm', colors: { color1: '#6b3a2a', color2: '#ffffff', color3: '#fde8d8', color4: '#6b3a2a', color5: '#e17055' } },
    { name: 'Minimal', colors: { color1: '#333333', color2: '#ffffff', color3: '#eeeeee', color4: '#f8f8f8', color5: '#333333' } }
];

class OnboardingGallery extends Component {
    constructor(props) {
        super(props);
        const detectedCountry = this.detectCountry();
        const config = COUNTRY_CONFIG[detectedCountry] || COUNTRY_CONFIG['US'];
        this.state = {
            step: 'country',
            country: detectedCountry,
            language: config.language,
            showVTA: config.showVTA,
            dateFormat: config.dateFormat,
            industry: config.industry,
            palette: 0,
            installing: false
        };
    }

    detectCountry() {
        const user = this.props.user || {};
        if (user.accounting && user.accounting.country) {
            const c = user.accounting.country.toUpperCase();
            if (c.length === 2 && COUNTRY_CONFIG[c]) return c;
        }
        if (user.shopify && user.shopify.country) {
            const c = user.shopify.country.toUpperCase();
            if (COUNTRY_CONFIG[c]) return c;
        }
        return 'US';
    }

    setCountry(code) {
        const config = COUNTRY_CONFIG[code] || COUNTRY_CONFIG['US'];
        this.setState({
            country: code,
            language: config.language,
            showVTA: config.showVTA,
            dateFormat: config.dateFormat
        });
    }

    getRecommendedTemplates() {
        const { industry } = this.state;
        return GalleryTemplates.filter(t => t.industry === industry && !t.isUniversal).map(t => t.name);
    }

    install() {
        this.setState({ installing: true });
        const templates = this.getRecommendedTemplates();
        const { language, showVTA, dateFormat, palette, country } = this.state;
        const langPreset = LANGUAGE_PRESETS.find(l => l.code === language);
        this.props.onInstall(templates, {
            language,
            labels: langPreset ? langPreset.labels : null,
            showVTA,
            dateFormat,
            colorPalette: COLOR_PALETTES[palette].colors,
            country
        });
    }

    render() {
        const { step, country, language, showVTA, dateFormat, industry, palette, installing } = this.state;

        return (
            <div className="onboarding-wizard">
                <style dangerouslySetInnerHTML={{__html: `
                    .onboarding-wizard { max-width: 720px; margin: 0 auto; padding: 40px 20px; }
                    .onboarding-wizard h2 { font-size: 22px; font-weight: 700; color: #1e293b; margin: 0 0 6px; }
                    .onboarding-wizard .subtitle { color: #64748b; font-size: 14px; margin-bottom: 28px; }
                    .onboarding-wizard .steps { display: flex; gap: 4px; margin-bottom: 32px; }
                    .onboarding-wizard .step-dot { height: 4px; flex: 1; border-radius: 2px; background: #e2e8f0; }
                    .onboarding-wizard .step-dot.active { background: #1e3a5f; }
                    .onboarding-wizard .step-dot.done { background: #22c55e; }
                    .onboarding-wizard .field-group { margin-bottom: 20px; }
                    .onboarding-wizard .field-group label { display: block; font-size: 12px; font-weight: 600; color: #475569; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.3px; }
                    .onboarding-wizard select, .onboarding-wizard input[type="text"] { width: 100%; padding: 10px 12px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 14px; color: #1e293b; background: #fff; }
                    .onboarding-wizard select:focus, .onboarding-wizard input[type="text"]:focus { outline: none; border-color: #1e3a5f; box-shadow: 0 0 0 3px rgba(30,58,95,0.08); }
                    .onboarding-wizard .row { display: flex; gap: 16px; }
                    .onboarding-wizard .row > * { flex: 1; }
                    .onboarding-wizard .nav-buttons { display: flex; justify-content: space-between; margin-top: 32px; padding-top: 20px; border-top: 1px solid #f1f5f9; }
                    .onboarding-wizard .btn-next { padding: 10px 24px; background: #1e3a5f; color: #fff; border: none; border-radius: 6px; font-size: 14px; font-weight: 600; cursor: pointer; }
                    .onboarding-wizard .btn-next:hover { background: #0f2a4a; }
                    .onboarding-wizard .btn-next:disabled { opacity: 0.5; cursor: not-allowed; }
                    .onboarding-wizard .btn-back { padding: 10px 20px; background: none; color: #64748b; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 14px; cursor: pointer; }
                    .onboarding-wizard .btn-back:hover { background: #f8fafc; }
                    .onboarding-wizard .palette-grid { display: flex; gap: 10px; flex-wrap: wrap; }
                    .onboarding-wizard .palette-option { width: 80px; padding: 10px 8px; border: 2px solid #e2e8f0; border-radius: 6px; cursor: pointer; text-align: center; transition: all 0.15s; }
                    .onboarding-wizard .palette-option:hover { border-color: #94a3b8; }
                    .onboarding-wizard .palette-option.selected { border-color: #1e3a5f; background: #f0f8ff; }
                    .onboarding-wizard .palette-option .swatch { display: flex; gap: 2px; justify-content: center; margin-bottom: 6px; }
                    .onboarding-wizard .palette-option .swatch span { width: 14px; height: 14px; border-radius: 3px; }
                    .onboarding-wizard .palette-option .name { font-size: 10px; color: #475569; font-weight: 500; }
                    .onboarding-wizard .toggle-row { display: flex; align-items: center; gap: 10px; padding: 10px 0; }
                    .onboarding-wizard .toggle-switch { position: relative; width: 40px; height: 22px; background: #cbd5e1; border-radius: 11px; cursor: pointer; transition: background 0.2s; }
                    .onboarding-wizard .toggle-switch.on { background: #1e3a5f; }
                    .onboarding-wizard .toggle-switch:after { content: ''; position: absolute; top: 3px; left: 3px; width: 16px; height: 16px; background: #fff; border-radius: 50%; transition: transform 0.2s; }
                    .onboarding-wizard .toggle-switch.on:after { transform: translateX(18px); }
                    .onboarding-wizard .toggle-label { font-size: 13px; color: #334155; }
                    .onboarding-wizard .tax-hint { font-size: 11px; color: #64748b; margin-top: 4px; }
                    .onboarding-wizard .industry-pills { display: flex; flex-wrap: wrap; gap: 8px; }
                    .onboarding-wizard .industry-pill { padding: 8px 14px; border: 1px solid #e2e8f0; border-radius: 20px; font-size: 12px; cursor: pointer; color: #475569; transition: all 0.15s; }
                    .onboarding-wizard .industry-pill:hover { border-color: #94a3b8; }
                    .onboarding-wizard .industry-pill.selected { background: #1e3a5f; color: #fff; border-color: #1e3a5f; }
                    .onboarding-wizard .summary-box { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px; margin-top: 16px; }
                    .onboarding-wizard .summary-box h4 { margin: 0 0 10px; font-size: 13px; font-weight: 600; color: #1e293b; }
                    .onboarding-wizard .summary-box ul { margin: 0; padding: 0; list-style: none; }
                    .onboarding-wizard .summary-box li { font-size: 12px; color: #475569; padding: 3px 0; }
                    .onboarding-wizard .summary-box li i { color: #22c55e; margin-right: 6px; width: 14px; }
                    .skip-link { color: #94a3b8; font-size: 12px; cursor: pointer; }
                    .skip-link:hover { color: #1e3a5f; }
                `}} />

                <div className="steps">
                    <div className={`step-dot ${step === 'country' ? 'active' : 'done'}`}></div>
                    <div className={`step-dot ${step === 'appearance' ? 'active' : step === 'confirm' ? 'done' : ''}`}></div>
                    <div className={`step-dot ${step === 'confirm' ? 'active' : ''}`}></div>
                </div>

                {step === 'country' && this.renderCountryStep()}
                {step === 'appearance' && this.renderAppearanceStep()}
                {step === 'confirm' && this.renderConfirmStep()}
            </div>
        );
    }

    renderCountryStep() {
        const { country, language } = this.state;
        const config = COUNTRY_CONFIG[country] || {};

        return (
            <div>
                <h2>Where is your business based?</h2>
                <p className="subtitle">We'll auto-configure tax display, date format, and document language for your region.</p>

                <div className="field-group">
                    <label>Country</label>
                    <select value={country} onChange={(e) => this.setCountry(e.target.value)}>
                        {COUNTRIES.map(c => <option key={c.code} value={c.code}>{c.name}</option>)}
                    </select>
                </div>

                <div className="field-group">
                    <label>Document Language</label>
                    <select value={language} onChange={(e) => this.setState({ language: e.target.value })}>
                        {LANGUAGE_PRESETS.map(l => <option key={l.code} value={l.code}>{l.name}</option>)}
                    </select>
                </div>

                {config.taxLabel && <div style={{background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:'6px', padding:'10px 14px', fontSize:'12px', color:'#166534'}}>
                    <i className="fa fa-check-circle" style={{marginRight:'6px'}}></i>
                    {config.showVTA
                        ? `${config.taxLabel} columns will be shown on your invoices`
                        : `Tax columns hidden by default (${config.taxLabel} applied at checkout)`}
                </div>}

                <div className="nav-buttons">
                    <span className="skip-link" onClick={() => this.props.onSkip && this.props.onSkip()}>Skip setup</span>
                    <button className="btn-next" onClick={() => this.setState({ step: 'appearance' })}>
                        Next: Appearance <i className="fa fa-arrow-right" style={{marginLeft:'6px'}}></i>
                    </button>
                </div>
            </div>
        );
    }

    renderAppearanceStep() {
        const { palette, industry, showVTA, dateFormat } = this.state;
        const config = COUNTRY_CONFIG[this.state.country] || {};

        return (
            <div>
                <h2>Customize your documents</h2>
                <p className="subtitle">Choose a color palette and your industry to get the right set of templates.</p>

                <div className="field-group">
                    <label>Color Palette</label>
                    <div className="palette-grid">
                        {COLOR_PALETTES.map((p, i) => (
                            <div key={p.name} className={`palette-option ${i === palette ? 'selected' : ''}`} onClick={() => this.setState({ palette: i })}>
                                <div className="swatch">
                                    <span style={{background: p.colors.color1}}></span>
                                    <span style={{background: p.colors.color4}}></span>
                                    <span style={{background: p.colors.color5}}></span>
                                </div>
                                <span className="name">{p.name}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="field-group">
                    <label>Industry</label>
                    <div className="industry-pills">
                        {INDUSTRIES.filter(i => i.id !== 'other').map(ind => (
                            <span key={ind.id} className={`industry-pill ${industry === ind.id ? 'selected' : ''}`} onClick={() => this.setState({ industry: ind.id })}>
                                <i className={`fa ${ind.icon}`} style={{marginRight:'5px'}}></i>{ind.name}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="row">
                    <div className="field-group">
                        <label>Date Format</label>
                        <select value={dateFormat} onChange={(e) => this.setState({ dateFormat: e.target.value })}>
                            <option value="DD/MM/YYYY">{formatDateExample('DD/MM/YYYY')} (DD/MM/YYYY)</option>
                            <option value="MM/DD/YYYY">{formatDateExample('MM/DD/YYYY')} (MM/DD/YYYY)</option>
                            <option value="YYYY-MM-DD">{formatDateExample('YYYY-MM-DD')} (YYYY-MM-DD)</option>
                            <option value="DD.MM.YYYY">{formatDateExample('DD.MM.YYYY')} (DD.MM.YYYY)</option>
                            <option value="DD-MM-YYYY">{formatDateExample('DD-MM-YYYY')} (DD-MM-YYYY)</option>
                            <option value="YYYY/MM/DD">{formatDateExample('YYYY/MM/DD')} (YYYY/MM/DD)</option>
                        </select>
                    </div>
                    <div className="field-group">
                        <label>Tax Display</label>
                        <div className="toggle-row">
                            <div className={`toggle-switch ${showVTA ? 'on' : ''}`} onClick={() => this.setState({ showVTA: !showVTA })}></div>
                            <span className="toggle-label">Show tax columns on invoices</span>
                        </div>
                        {config.taxLabel && <div className="tax-hint">Recommended for {config.taxLabel} in your region</div>}
                    </div>
                </div>

                <div className="nav-buttons">
                    <button className="btn-back" onClick={() => this.setState({ step: 'country' })}>
                        <i className="fa fa-arrow-left" style={{marginRight:'6px'}}></i> Back
                    </button>
                    <button className="btn-next" onClick={() => this.setState({ step: 'confirm' })}>
                        Next: Review <i className="fa fa-arrow-right" style={{marginLeft:'6px'}}></i>
                    </button>
                </div>
            </div>
        );
    }

    renderConfirmStep() {
        const { country, language, showVTA, dateFormat, industry, palette, installing } = this.state;
        const config = COUNTRY_CONFIG[country] || {};
        const countryName = (COUNTRIES.find(c => c.code === country) || {}).name || country;
        const langName = (LANGUAGE_PRESETS.find(l => l.code === language) || {}).name || language;
        const industryName = (INDUSTRIES.find(i => i.id === industry) || {}).name || industry;
        const templates = this.getRecommendedTemplates();
        const paletteObj = COLOR_PALETTES[palette];

        return (
            <div>
                <h2>Ready to go!</h2>
                <p className="subtitle">We'll install {templates.length} templates optimized for your business and apply these settings.</p>

                <div className="summary-box">
                    <h4>Your configuration</h4>
                    <ul>
                        <li><i className="fa fa-globe"></i> Country: <b>{countryName}</b></li>
                        <li><i className="fa fa-language"></i> Language: <b>{langName}</b></li>
                        <li><i className="fa fa-calendar"></i> Date format: <b>{dateFormat}</b></li>
                        <li><i className="fa fa-percent"></i> Tax columns: <b>{showVTA ? 'Visible' : 'Hidden'}{config.taxLabel ? ` (${config.taxLabel})` : ''}</b></li>
                        <li><i className="fa fa-briefcase"></i> Industry: <b>{industryName}</b></li>
                        <li><i className="fa fa-paint-brush"></i> Palette: <b>{paletteObj.name}</b></li>
                    </ul>
                </div>

                <div className="summary-box" style={{marginTop:'12px'}}>
                    <h4>Templates to install ({templates.length})</h4>
                    <ul>
                        {templates.map(t => <li key={t}><i className="fa fa-file-text-o"></i> {t.replace(/^[^-]+ - /, '')}</li>)}
                    </ul>
                </div>

                <div className="nav-buttons">
                    <button className="btn-back" onClick={() => this.setState({ step: 'appearance' })}>
                        <i className="fa fa-arrow-left" style={{marginRight:'6px'}}></i> Back
                    </button>
                    <button className="btn-next" disabled={installing} onClick={() => this.install()}>
                        {installing ? 'Setting up...' : 'Install & Configure'}
                    </button>
                </div>
            </div>
        );
    }
}

export default OnboardingGallery;



// WEBPACK FOOTER //
// app/components/OnboardingGallery.jsx